const suppressConsole = () => {
    console.info = () => undefined;
    console.warn = () => undefined;
    console.error = () => undefined;
    console.log = () => undefined;
};

const error = (message) => {
  console.error(message);
};

const Logger = {
  error,
  suppressConsole,
};

export default Logger;
